module.exports = __webpack_public_path__ + "img/zhangmen.b1fd9177.png";